(function ($) {

	var $iframes = $('iframe.js-get-iframe');

	$iframes.each(function () {
        var $iframe = $(this);
        var $iframeWrapper = $(this).parents('.js-iframe-wrapper');
        var $spinner = $iframeWrapper.siblings('.js-spinner');
		var dataSrc = $iframe.attr('data-src');

        $iframe.on('load', function () {
			$iframeWrapper.addClass('loaded');
			$spinner.hide();
			$iframe.height(600);
        });

        $iframe.attr('src', dataSrc);
		$spinner.show();
	});

})(jQuery);
